import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: { totalItems: null },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  // CRUD operations
  async getAll({ commit }, { organizationId, config = {} }) {
    const data = get(
      await this.$axios.get(routes.organizationusers.users(organizationId), config),
      'data'
    )
    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'organizationusers',
        items: data,
        meta: {}, // todo: change once meta will be added on BE for this request
        params: config.params
      },
      { root: true }
    )

    return data
  },
  async create({ commit }, { payload = {}, config = {} }) {
    const data = get(
      await this.$axios.post(routes.organizationusers.list(), payload, config),
      'data'
    )
    commit(
      'AFTER_CREATE',
      {
        namespace: 'organizationusers',
        item: data
      },
      { root: true }
    )
    return data
  },
  async read({ commit }, { id, config = {} }) {
    const data = get(
      await this.$axios.get(routes.organizationusers.concrete(id), config),
      'data'
    )
    commit('AFTER_READ', { namespace: 'organizationusers', item: data }, { root: true })
    return data
  },
  async update({ commit }, { id, payload, config = {} }) {
    const data = get(
      await this.$axios.put(routes.organizationusers.concrete(id), payload, config),
      'data'
    )
    commit('AFTER_UPDATE', { namespace: 'organizationusers', item: data }, { root: true })
    return data
  },
  async delete({ commit }, { id, config = {} }) {
    const response = await this.$axios.delete(routes.organizationusers.concrete(id), config)
    commit('AFTER_DELETE', { namespace: 'organizationusers', id }, { root: true })
    return response
  },
  // common requests
  notify({ commit }, { id, payload, config = {} }) {
    return this.$axios.put(routes.organizationusers.notify(id), payload, config)
  }
}
